// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page":"Page-db262ba9fc67b9c1","anchovy":"Page-75937565b2388389"};